import React from "react";
import { Bar, Pie } from "react-chartjs-2";
import { Row, Col } from "reactstrap";

//Getting archive and created Tasks as props
const Chart = ({ createdTasks, archivedTasks }) => {
  const pieRatioData = {
    labels: ["Created / Active", "Archived"],
    datasets: [
      {
        data: [createdTasks.length, archivedTasks.length],
        backgroundColor: ["#36A2EB", "#cccccc"],
        hoverBackgroundColor: ["rgb(54, 162, 235,0.8)", "gray"],
      },
    ],
  };
  let activeLabel = [0, 0, 0, 0]; //Count tasks with label "Personal","Work","Shopping","Others" in Active Tasks
  let archiveLabel = [0, 0, 0, 0]; //Count tasks with label "Personal","Work","Shopping","Others" in Archived Tasks
  let activeStatus = [0, 0, 0]; //Count tasks with status "New","In progress", "Completed" in Active Tasks
  let archiveStatus = [0, 0, 0]; //Count tasks with status "New","In progress", "Completed" in Archived Tasks

  //mapping over created task to count above mentioned fields
  createdTasks.map((task) => {
    if (task.label === "Personal") {
      activeLabel[0]++;
    } else if (task.label === "Work") {
      activeLabel[1]++;
    } else if (task.label === "Shopping") {
      activeLabel[2]++;
    } else {
      activeLabel[3]++;
    }
    if (task.status === "New") {
      activeStatus[0]++;
    } else if (task.status === "In Progress") {
      activeStatus[1]++;
    } else {
      activeStatus[2]++;
    }
    return 0;
  });

  //mapping over archived task to count above mentioned fields
  archivedTasks.map((task) => {
    if (task.label === "Personal") {
      archiveLabel[0]++;
    } else if (task.label === "Work") {
      archiveLabel[1]++;
    } else if (task.label === "Shopping") {
      archiveLabel[2]++;
    } else {
      archiveLabel[3]++;
    }
    if (task.status === "New") {
      archiveStatus[0]++;
    } else if (task.status === "In Progress") {
      archiveStatus[1]++;
    } else {
      archiveStatus[2]++;
    }
    return 0;
  });

  //Making the Bar graph settings to show the status related to Labels
  const barLabelData = {
    labels: ["Personal", "Work", "Shopping", "Others"],
    datasets: [
      {
        label: "Active",
        backgroundColor: "rgb(54, 162, 235,0.2)",
        borderColor: "rgb(54, 162, 235,1)",
        hoverBackgroundColor: "rgb(54, 162, 235,0.4)",
        hoverBorderColor: "rgb(54, 162, 235,1)",
        borderWidth: 1,
        data: [...activeLabel],
      },
      {
        label: "Archived",
        backgroundColor: "rgb(204, 204, 204,0.2)",
        borderColor: "rgb(204, 204, 204,1)",
        hoverBackgroundColor: "rgb(204, 204, 204,0.4)",
        hoverBorderColor: "rgb(204, 204, 204,1)",
        borderWidth: 1,
        data: [...archiveLabel],
      },
    ],
  };

  //Making the Bar graph settings to show the status related to Status
  const barStatusData = {
    labels: ["New", "In Progress", "Completed"],
    datasets: [
      {
        label: "Active",
        backgroundColor: "rgb(54, 162, 235,0.2)",
        borderColor: "rgb(54, 162, 235,1)",
        hoverBackgroundColor: "rgb(54, 162, 235,0.4)",
        hoverBorderColor: "rgb(54, 162, 235,1)",
        borderWidth: 1,
        data: [...activeStatus],
      },
      {
        label: "Archived",
        backgroundColor: "rgb(204, 204, 204,0.2)",
        borderColor: "rgb(204, 204, 204,1)",
        hoverBackgroundColor: "rgb(204, 204, 204,0.4)",
        hoverBorderColor: "rgb(204, 204, 204,1)",
        borderWidth: 1,
        data: [...archiveStatus],
      },
    ],
  };
  //Passing data to respective charts
  return (
    <div className="chart">
      <p>These all Stats is for the whole Data Set without any Filters.</p>
      <Row>
        <Col md={12} className="my-2 my-md-5">
          <h4>Task Ratio</h4>
          <Pie data={pieRatioData} />
        </Col>
        <Col md={6} className="my-2 my-md-5">
          <h4>Label Types in Task Types</h4>
          <Bar data={barLabelData} />
        </Col>
        <Col md={6} className="my-2 my-md-5">
          <h4>Status Types in Task Types</h4>

          <Bar data={barStatusData} />
        </Col>
      </Row>
    </div>
  );
};

export default Chart;
